import { render, staticRenderFns } from "./poi-card-slider.vue?vue&type=template&id=cd45f95e&scoped=true&"
import script from "./poi-card-slider.vue?vue&type=script&lang=ts&"
export * from "./poi-card-slider.vue?vue&type=script&lang=ts&"
import style0 from "./poi-card-slider.vue?vue&type=style&index=0&id=cd45f95e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd45f95e",
  null
  
)

export default component.exports